import React, {useEffect, useState} from "react";
import Spaces from "./Spaces";
import Equipment from "./Equipment";
import Schedules from "./Schedules";
import Location from "./Location";


const Subsearch = (props) => {
	const [allFilters, setAllFilters] = useState({})

	const updateFilters = (type, newFilters) => {
		let filters = Object.assign({}, allFilters)
		filters[type] = Object.assign([], newFilters)
		setAllFilters(filters)
	}

	const removeTag = (type, filter) => {
		let filters = Object.assign({}, allFilters)
		filters[type] = Object.assign([], allFilters[type].filter(f => f.id != filter.id))
		setAllFilters(filters)
	}

	useEffect(() => {
		props.callback(allFilters)
	}, [allFilters])

	const drawTag = (type, filter) => {
		let tagClass = "tag " + type.toLowerCase();
		return <div key={filter.name} className={tagClass}>{filter.name}<div className="tag-out" onClick={() => removeTag(type, filter)}>x</div></div>
	}

	console.log("Allfilters")
	console.log(allFilters)

	let tags = ""
	
    return (
        <div className="subsearch">
            <Location searchResults={props.searchResults} callbackFunction={updateFilters} filters={allFilters["Site"]}/>
            <Spaces searchResults={props.searchResults} callbackFunction={updateFilters} filters={allFilters["Space"]} />
            <Equipment searchResults={props.searchResults}  callbackFunction={updateFilters}/>
            {/* <Schedules />  */}

			<div className="subsearch-tags">
			{ Object.keys(allFilters).map((type) => {
					return allFilters[type].map(f => {
						return drawTag(type, f)
					})
				})
			} 
			</div>
        </div>
    )
}

export default Subsearch;